// SEED IMS Design Tokens
// Colors themed to Grenada flag colors (Red, Yellow, Green)

export const palette = {
  primary: {
    main: "#CE1126", // Grenada Red
    dark: "#A00D1E", // Darker red
    light: "#E63946" // Lighter red
  },
  secondary: {
    main: "#007A5E", // Grenada Green
    dark: "#00604A", // Darker green
    light: "#009B75" // Lighter green
  },
  background: {
    default: "#f4f7fc", // Light blue-gray background
    paper: "#ffffff"
  },
  text: {
    primary: "#20263a", // Dark text
    secondary: "#6c757d" // Muted text
  },
  success: {
    main: "#007A5E" // Grenada Green for success states
  },
  error: {
    main: "#CE1126" // Grenada Red for error states
  },
  warning: {
    main: "#FCD116" // Grenada Yellow for warning states
  },
  info: {
    main: "#007A5E" // Grenada Green for info states
  }
} as const;
